import { createFileRoute } from '@tanstack/react-router';

// relative imports
import TrialEndedPage from '../../components/account-management/TrialEndedPage';
import LoadingPage from '../../components/shared/page-components/LoadingPage';

export const Route = createFileRoute('/_authenticated/trial-expired')({
  component: TrialEndedPage,
  pendingComponent: () => <LoadingPage loadingPage hideSecondaryMenu />,
  staticData: {
    hideSecondaryMenu: true,
  },
});
